import React, { useEffect } from "react";
import Seo from "../Components/Seo";
import PageHero from "../Components/PageHero";
import ServiceCard from "../Components/ServiceCard";
import CTASection from "../Components/CTASection";
import { SERVICES } from "../data/services";
import { SITE } from "../data/site";

const ServicesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: SERVICES.map((s, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: s.name,
      url: `${SITE.domain}/services/${s.slug}`,
    })),
  };

  return (
    <>
      <Seo
        title="Technology Services | Triguna Solutions"
        description="Explore Triguna Solutions' technology services: Generative AI, mobile app development, web development, cloud engineering, data engineering, and product engineering."
        path="/services"
        jsonLd={jsonLd}
      />

      <PageHero
        eyebrow="Our Services"
        title="Technology Services Designed for Modern Businesses"
        subtitle="From frontier AI to cloud-native platforms, we engineer solutions that move your business forward — at startup speed and enterprise scale."
      />

      {/* Grid */}
      <section className="px-4 py-20 sm:px-6 sm:py-24 lg:px-8">
        <div className="mx-auto grid max-w-7xl gap-6 md:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((service, i) => (
            <ServiceCard key={service.slug} service={service} index={i} />
          ))}
        </div>
      </section>

      <CTASection />
    </>
  );
};

export default ServicesPage;
